(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);
/*  this screen view for all entity  */
    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('trades-for-the-day-report', {
            parent: 'entity',
            params:{screen: 'TradesForTheDay'}, 
            url: '/trades-for-the-day-report',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.tradesForTheDayReport.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/clearcorp-trades-report/clearcorp-trades-report.html',
                    controller: 'ClearCorpTradesReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearcorpTradesReport');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('orderActivity');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('order-activity-report-from-trades', {
            parent: 'trades-for-the-day-report',
            url: '/order-activity-report-for-trades/{orderNumber}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order-activity/order-activity.html',
                    controller: 'OrderActivityController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    	
                            	 entity: ['OrderActivity', 'GlobalValues', function(OrderActivity, GlobalValues) {
                                     return OrderActivity.get({orderNumber : $stateParams.orderNumber}).$promise;
                                 }],
                                 businessDate: [ 'GlobalValues','DateUtils', function( GlobalValues,DateUtils) {
                                	 var systemSettings = GlobalValues.getSystemSettings();
                                     if(systemSettings!=null && systemSettings!=undefined){
                                     	return DateUtils.convertLocalDateFromServer(systemSettings.businessDate);
                                     	 
                                     }else{
                                    	 return null;
                                     }
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
             
        
         
         };
    })();
